import React from "react";
import s from "./NewCars.module.scss";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getNewCars } from "../../redux/carSlice";
import { useTranslation } from "react-i18next";
const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
  const {
    carouselState: { currentSlide },
  } = rest;
  return (
    <div className='carousel-button-group'>
      <button
        className={currentSlide === 0 ? "disable" : ""}
        onClick={() => previous()}
      />
      <button onClick={() => next()} />
      <button onClick={() => goToSlide(currentSlide + 1)}>
        {" "}
        Go to any slide{" "}
      </button>
    </div>
  );
};

const NewCars = () => {
  const newCars = useSelector((state) => state.cars.newCars);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <div className={s.new_cars}>
      <div className={s.titles}>
        <Link
          to={`/category/new`}
          className={s.title}
          onClick={() => dispatch(getNewCars())}
        >
          {t("newCarsFromSalon")}
        </Link>
        <Link
          to={`/category/new`}
          className={s.title2}
          onClick={() => dispatch(getNewCars())}
        >
          {t("all")} {t("newCarsFromSalon").toLowerCase()} (
          {Array.isArray(newCars) && newCars?.length})
        </Link>
      </div>

      {/* <div className={s.title}>Новые авто из салонов</div> */}
      <div className={s.cars_carousel}>
        <Carousel customButtonGroup={<ButtonGroup />} responsive={responsive}>
          {newCars?.map((it) => (
            <Link to={`/car/${it.id}`} key={it.id}>
              <div className={s.item}>
                <img src={it.images[0]?.image} className={s.item_img} />
                <div className={s.price}>$ {it.price}</div>
              </div>
            </Link>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default NewCars;
